// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Chat_wrapper__23AhC","scrollableDiv":"Chat_scrollableDiv__3PcQq","loader":"Chat_loader__3bNZb","toBottomButton":"Chat_toBottomButton__17BnS"};